import { ISpinProps, Spin as MolySpin } from '@bfe/moly';
import { LoadingIcon } from '@bfe/moly-icons';

const Indicator = () => {
  return (
    <div className="text-center">
      <LoadingIcon className="text-brandColor-bds-brand-700-normal text-bds-font-size-h4 animate-spin !w-8 !h-8" />
    </div>
  );
};

const Spin = ({ children, indicator, ...props }: ISpinProps) => {
  let indicatorProps = {};

  // 如果传入自定义加载指示符 或者 使用moly组件默认加载指示符
  if (indicator) {
    indicatorProps = indicator === 'default' ? {} : { indicator };
  } else {
    // 不传入 indicator 则默认使用用户服务自定义的通用指示符
    indicatorProps = { indicator: <Indicator /> };
  }

  return (
    <MolySpin {...props} {...indicatorProps}>
      {children}
    </MolySpin>
  );
};

export default Spin;
